module.exports = __webpack_public_path__ + "img/Reality-Copy-2.83721ad.png";